import { useState, useEffect } from "react";
import { apiFetch } from "../../../context/AuthContext";

export function useEmployeeStats(BASE_URL) {
  const [employeeCount, setEmployeeCount] = useState(0);
  const [totalCompanies, setTotalCompanies] = useState(15);
  const [counts, setCounts] = useState({ Active: 0, OnLeave: 0, Recent: 0 });
  const [payrollTotal, setPayrollTotal] = useState(0);

  // Fetch employee total count
  useEffect(() => {
    apiFetch(`${BASE_URL}/employees/count`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setEmployeeCount(data.count))
      .catch((err) => console.error(err));
  }, []);

  // Fetch counts for Active, OnLeave, and Recent employees
  useEffect(() => {
    async function fetchCounts() {
      try {
        const activeRes = await apiFetch(`${BASE_URL}/employees/Active`, {
          method: "GET",
        });
        const onLeaveRes = await apiFetch(`${BASE_URL}/employees/OnLeave`, {
          method: "GET",
        });
        const active = await activeRes.json();
        const onLeave = await onLeaveRes.json();
        setCounts({
          Active: active.count,
          OnLeave: onLeave.count,
          Recent: 7,
        });
      } catch (err) {
        console.error(err);
      }
    }
    fetchCounts();
  }, []);

  // Fetch total payroll
  useEffect(() => {
    apiFetch(`${BASE_URL}/payroll/total`, { method: "GET" })
      .then((res) => res.json())
      .then((data) => setPayrollTotal(data.total))
      .catch((err) => console.error(err));
  }, []);

  return { employeeCount, totalCompanies, counts, payrollTotal };
}